import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { CashbackStatus, NotificationManager } from '@atlas/core';
import { Button, SimpleTimer } from '@atlas/ui';

import Status from './Status';

const CashBackStatus = ({ cashback, handleActivate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { accrualDeactivationTime, activationTime, id, status } = cashback;

  const handleActiveCashback = useCallback(async () => {
    setIsLoading(true);

    try {
      await handleActivate(id);
    } catch (error) {
      NotificationManager.notify({
        message: 'Error activating cashback',
        status: 'error',
        type: 'notification',
      });
    } finally {
      setIsLoading(false);
    }
  }, [handleActivate, id]);

  return (
    <>
      {status === CashbackStatus.FINISHED && <Status status={status} />}
      {status === CashbackStatus.ACTIVE && activationTime && accrualDeactivationTime && (
        <Status hasCashbackInfo status={status}>
          <div className="activated-cashback">
            <SimpleTimer time={accrualDeactivationTime} />
          </div>
        </Status>
      )}
      {status === CashbackStatus.ACTIVE && (!activationTime || !accrualDeactivationTime) && (
        <Status status={status} />
      )}
      {status === CashbackStatus.CREATED && (
        <div className="activated-container">
          <Button
            className="block"
            disabled={isLoading}
            label="Activate"
            loading={isLoading}
            onClick={handleActiveCashback}
            size="medium"
            type="primary"
          />
        </div>
      )}
    </>
  );
};

CashBackStatus.propTypes = {
  cashback: PropTypes.shape({
    accrualDeactivationTime: PropTypes.number.isRequired,
    accrualFrequency: PropTypes.string.isRequired,
    activationTime: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    status: PropTypes.oneOf(CashbackStatus).isRequired,
  }).isRequired,
  handleActivate: PropTypes.func.isRequired,
};

export default CashBackStatus;
